import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Stopka from "../components/stopka";
import zdjecie1 from "../components/zdjecia/matecznikzdjecia/matecznik-01.jpg";
import zdjecie2 from "../components/zdjecia/matecznikzdjecia/matecznik-02.jpg";
import zdjecie3 from "../components/zdjecia/matecznikzdjecia/matecznik-03.jpg";
import zdjecie4 from "../components/zdjecia/matecznikzdjecia/matecznik-04.jpg";
import zdjecie5 from "../components/zdjecia/matecznikzdjecia/matecznik-05.jpg";
import zdjecie6 from "../components/zdjecia/matecznikzdjecia/matecznik-06.jpg";
import zdjecie7 from "../components/zdjecia/matecznikzdjecia/matecznik-07.jpg";
import plakatMatecznika from "../components/zdjecia/spetakle/spetakle-matecznik.jpg";

const gallery = [
    { src: zdjecie1, alt: "Matecznik - scena spektaklu" },
    { src: zdjecie2, alt: "Matecznik - scena spektaklu" },
    { src: zdjecie3, alt: "Matecznik - fotografia Pawła Gorszewskiego" },
    { src: zdjecie4, alt: "Matecznik - fotografia Pawła Gorszewskiego" },
    { src: zdjecie5, alt: "Matecznik - fotografia Pawła Gorszewskiego" },
    { src: zdjecie6, alt: "Matecznik - fotografia Pawła Gorszewskiego" },
    { src: zdjecie7, alt: "Matecznik - fotografia Pawła Gorszewskiego" },
];

const Matecznik = () => {
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        document.body.style.overflow = selectedImage ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [selectedImage]);

    return (
        <div className="bg-[#0d0d0d] min-h-screen text-white">
            <Navbar />
            <main className="pt-32">
                <section className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16 pb-20">
                    <p className="text-red-400 text-xs uppercase tracking-[0.3em] text-center mb-4">
                        Spektakl Teatru Łątek Supraśl
                    </p>
                    <div className="max-w-3xl mx-auto mb-10 overflow-hidden rounded-2xl border border-white/10 shadow-2xl shadow-black/40">
                        <img
                            src={plakatMatecznika}
                            alt="Matecznik"
                            className="w-full max-h-[520px] object-cover"
                        />
                    </div>
                    <h1 className="text-4xl md:text-6xl font-semibold text-center tracking-wide mb-8">
                        Matecznik
                    </h1>
                    <div className="w-16 h-px bg-red-500 mx-auto mb-12" />

                    <div className="max-w-3xl mx-auto">
                        <p className="text-base md:text-lg leading-relaxed text-gray-300">
                            Główną inspiracją do powstania widowiska pt. „Matecznik” stanowi wydany w 1984 roku
                            „album fotograficznym” Wiktora Wołkowa pt.: „Rzeka, droga, płoty, krowy, konie, stogi,
                            wrony, bociany, drzewa, krzyże”. Wydawnictwo zrealizowało trzech wybitnych artystów:
                            Wiktor Wołkow – autor zdjęć, Edward Redliński – autor zamieszczonych opowieści oraz
                            Andrzej Strumiłło, który stworzył koncepcję oraz opracował ją graficznie.
                        </p>
                        <p className="text-base md:text-lg leading-relaxed text-gray-300 mt-6">
                            Zamieszczone w albumie zdjęcia inspirują do stawiania pytań: o los człowieka;
                            o indywidualność; o przyjaźń; o istnienie smutku na świecie.
                        </p>
                    </div>

                    <section className="mt-20" aria-labelledby="matecznik-galeria">
                        <h2 id="matecznik-galeria" className="text-2xl md:text-3xl font-semibold text-center mb-3">
                            Galeria
                        </h2>
                        <div className="w-12 h-px bg-red-500 mx-auto mb-8" />
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {gallery.map((image, index) => (
                                <button
                                    key={image.src}
                                    type="button"
                                    onClick={() => setSelectedImage(image)}
                                    className={`group relative overflow-hidden rounded-xl border border-white/10 bg-[#161616] ${
                                        index === 0 ? "sm:col-span-2 lg:col-span-2" : ""
                                    }`}
                                    aria-label={`Powiększ zdjęcie ${index + 1}`}
                                >
                                    <img
                                        src={image.src}
                                        alt={image.alt}
                                        className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                    <span className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors duration-300" />
                                </button>
                            ))}
                        </div>
                    </section>
                </section>
            </main>

            <Stopka />

            {selectedImage && (
                <div
                    className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/90"
                    onClick={() => setSelectedImage(null)}
                    role="dialog"
                    aria-modal="true"
                    aria-label="Powiększone zdjęcie"
                >
                    <button
                        type="button"
                        onClick={() => setSelectedImage(null)}
                        className="absolute top-6 right-6 text-white/80 hover:text-white text-2xl"
                        aria-label="Zamknij zdjęcie"
                    >
                        ✕
                    </button>
                    <img
                        src={selectedImage.src}
                        alt={selectedImage.alt}
                        className="max-w-full max-h-[90vh] object-contain rounded-lg"
                        onClick={(event) => event.stopPropagation()}
                    />
                </div>
            )}
        </div>
    );
};

export default Matecznik;
